// components/NotFound.jsx
import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const { pathname } = useLocation();
  const loggedIn = !!localStorage.getItem("user_id");

  return (
    <div className="min-vh-100 d-flex flex-column align-items-center justify-content-center text-center p-4">
      <h1 className="display-5 mb-2">404</h1>
      <p className="text-muted mb-4">
        The page doesn’t exist.
      </p>
      <div className="d-flex gap-2">
        <Link className="btn btn-success" to={loggedIn ? "/assessment_dashboard" : "/login"}>
          Go to {loggedIn ? "Dashboard" : "Login"}
        </Link>
        <Link className="btn btn-outline-secondary" to="/">Home</Link>
      </div>
    </div>
  );
}
